import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  type: string;
  name: string;
  epics?: string[] | null;
};

export const useSchemaEpicGroup = (
  projectData: ProjectDto,
  initialValue: FormValueType,
  selectedEpicType?: string,
) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingEpicGroups = projectData.epicGroups
    .filter((epicGroup) => selectedEpicType === epicGroup.type)
    .map((epicGroup) => epicGroup.name?.toLocaleLowerCase())
    .filter((epicGroup) => {
      if (initialValue.name && initialValue.type === selectedEpicType) {
        return epicGroup !== initialValue?.name?.toLocaleLowerCase();
      }
      return true;
    });

  return useMemo(
    () =>
      Yup.object().shape({
        type: Yup.string(),
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingEpicGroups, t('addEpicGroups.existing'))
          .max(250),
        epics: Yup.array().min(1).required(),
      }),
    [t, existingEpicGroups],
  );
};
